<template>
  <div class="vt-date-picker">
    <date-picker
      ref="datePicker"
      v-model="date"
      :not-after="notAfter"
      :not-before="notBefore"
      :lang="lang"
      :type="type"
      :disabled="disabled"
      :placeholder="internalPlaceholder"
      :time-picker-options="timePickerOptions"
      :format="internalFormat"
      :data-vv-name="name"
      @input-error="handleInputError"
      @clear="$emit('clear')"
      @input="$emit('update', $event)"
    />
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker'
import sessionStore from '@/session/sessionStore'
import moment from 'moment'
import { uniqueId } from 'lodash'
import { DateUtils } from '@/shared/util/date-utils'

export default {
    name: 'VtDatePicker',
    components: { DatePicker },
    props: {
        type: { type: String, default: 'datetime' }, // 'date' | 'datetime'
        model: { type: [Date, Object, String] },
        timePickerOptions: { type: Object,
            default: () => {
                return {
                    start: '00:00',
                    step: '00:15',
                    end: '23:45'
                }
            } },
        format: { type: String },
        placeholder: { type: String },
        disabled: { type: Boolean, default: false },
        notAfter: { type: [Date, Object, Boolean], default: false },
        notBefore: { type: [Date, Object, Boolean], default: false },
        name: { type: String, default: () => uniqueId('datePicker') }
    },
    data() {
        return {
            value: '',
            date: this.model,
            internalFormat: null,
            internalPlaceholder: null
        }
    },
    computed: {
        lang() {
            return sessionStore.getLocale()
        },
        _pattern() {
            return this.type === 'datetime' ? DateUtils.localeDateTimePattern : DateUtils.localeDatePattern
        }
    },
    watch: {
        model(newDate) {
            this.date = newDate
        }
    },
    mounted() {
        this.internalFormat = this.format ?? this._pattern
        this.internalPlaceholder = this.placeholder ?? this._pattern
    },
    methods: {
        handleInputError(input) {
            if (this.type === 'datetime') {
                const notAfterValidation = this.notAfter ? input < this.notAfter : true
                const notBeforeValidation = this.notBefore ? input > this.notBefore : true
                if (notBeforeValidation && notAfterValidation) {
                    this.date = moment(input, this.internalFormat).format()
                    this.$emit('update', this.date)
                }
            }
        },
        focus() {
            this.$refs.datePicker.$refs.input.focus()
        },
        getDate() {
            return this.date
        },
        setDate(date) {
            this.date = date
            this.value = date ? date.toISOString() : ''
        },
        onInput(value) {
            const changed = this.value !== value
            if (changed) {
                this.value = value
                this.date = new Date(value)
                this.params.onDateChanged()
            }
        },
        clear() {
            this.value = ''
            this.date = null
            this.params.onDateChanged()
        }
    }
}

</script>

<style scoped lang="scss">

.vt-date-picker {
    ::v-deep .vdatetime {
    display: inline-block;
  }
}

.vt-date-picker-clear {
  margin-right: 5px;
  cursor: pointer;
}

.mx-datepicker{
  width: 100%;
}

</style>
